import { Component } from '@angular/core';

import { BaseMultiText } from '../../../../translation';
import { currentBuilderState } from '../../builder.state';
import { filterMetrics } from '../../function/filter-metrics.function';
import {
    moveMetricDown,
    moveMetricUp,
} from '../../function/move-metric.function';
import { removeMetric } from '../../function/remove-metric.function';
import { selectMetric } from '../../function/select-metric.function';
import { BuilderState } from '../../model/builder-state.model';

@Component({
    selector: 'cmps-report-builder-cache-metric',
    templateUrl: './cache-metric.component.html',
})
export class CacheMetricComponent {
    /** @private */
    _state: BuilderState;

    constructor() {
        this._state = currentBuilderState();
    }

    /** @private */
    _onKeywordChange(keyword: string | null): void {
        this._state.metricKeywords = keyword;
        filterMetrics();
    }

    /** @private */
    _onMetricClick(m: BaseMultiText): void {
        selectMetric(m);
    }

    /** @private */
    _onMoveUpClick(m: BaseMultiText): void {
        moveMetricUp(m);
    }

    /** @private */
    _onMoveDownClick(m: BaseMultiText): void {
        moveMetricDown(m);
    }

    /** @private */
    _onRemoveClick(m: BaseMultiText): void {
        removeMetric(m);
    }
}
